var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8BA6C1",
    d: "M10.374 10.926l2.879 2.924-10.268 5.835c-.319.21-.684.315-1.05.315-.148 0-.296-.019-.442-.054l8.881-9.02zM.39.786L9.462 10 .39 19.214c-.247-.335-.39-.745-.39-1.18V1.965c0-.434.143-.845.39-1.18zm14.033 6.028l2.587 1.47c.62.353.99.994.99 1.716 0 .721-.37 1.362-.99 1.715l-2.587 1.47L11.286 10l3.137-3.186zM1.493.053C1.998-.07 2.537.02 2.985.315L13.253 6.15l-2.879 2.923z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.c3f6f9d58f8c1fef49ad3105570fc348.svg";
export { ForwardRef as ReactComponent };